import React, { useEffect, useState} from 'react';
import { compose } from 'recompose';

import { Button, Col, Row } from 'react-bootstrap';
import LoadingOverlay from 'react-loading-overlay';
import ReactEcharts from 'echarts-for-react';

import DatePicker from "react-datepicker";

import { API, Auth } from 'aws-amplify'

const PROVISIONAL_TEMPERATURE_FAHRENHEIT = 99;
const PROVISIONAL_TEMPERATURE_CELSIUS = 37.2222;

const CDC_FEVER_FAHRENHEIT = 100.4;
const CDC_FEVER_CELSIUS = 38;


const CHART_DEFAULT_MAXIMUM_FAHRENHEIT = 101;
const CHART_DEFAULT_MINIMUM_FAHRENHEIT = 96;

const CHART_DEFAULT_MAXIMUM_CELSIUS = 38.5;
const CHART_DEFAULT_MINIMUM_CELSIUS = 35.5;

const CHART_DEFAULT_LOOKBACK_DAYS = 30;


function TemperatureChartModuleBase(props) {
    const [showBusy, setShowBusy] = useState(true);
    
    const [temperatureData, setTemperatureData] = useState([]);
  

    const [warningTemperature, setWarningTemperature] = useState('');
  
  
    const [chartUpper, setChartUpper] = useState(CHART_DEFAULT_MAXIMUM_FAHRENHEIT);
    const [chartLower, setChartLower] = useState(CHART_DEFAULT_MINIMUM_FAHRENHEIT);
    const [chartUnit, setChartUnit] = useState('℉');
  
    const [temperatureDataMeanArray, setTemperatureDataMeanArray] = useState([]);
    const [temperatureDataChannelUpperArray, setTemperatureDataChannelUpperArray] = useState([]);
    const [temperatureDataChannelLowerArray, setTemperatureDataChannelLowerArray] = useState([]);
    const [temperatureDataPersonalWarningArray, setTemperatureDataPersonalWarningArray] = useState([]);
    const [temperatureDataProvisionalWarningArray, setTemperatureDataProvisionalWarningArray] = useState([]);
    const [temperatureDataCDCFeverArray, setTemperatureDataCDCFeverArray] = useState([]);
    
    const [showOverlay, setShowOverlay] = useState(false);
  
    const [hasUpdatedPlottingUnit, setHasUpdatedPlottingUnit] = useState(false);
    const [preferredPlottingUnit, setPreferredPlottingUnit] = useState('fahrenheit');
  
    const [endDate, setEndDate] = useState((new Date()));
    const [startDate, setStartDate] = useState((new Date(Date.now() - CHART_DEFAULT_LOOKBACK_DAYS * 24 * 60 * 60 * 1000)));
  
    const assessmentData = props.assessment;

    const [plottingData, setPlottingData] = useState([]);
      
    const chartHeight = 350

    function fahrenheitToCelsius(fahrenheit: number) {
      return ((fahrenheit - 32.0) * (5.0 / 9.0 ))
    }
  
    function updatePlottingUnit(unit) {
      setHasUpdatedPlottingUnit(true);
      setPreferredPlottingUnit(unit);
    }
  
    function formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = '' + d.getFullYear(),
          hour = '' + d.getHours(),
          minutes = '' + d.getMinutes(),
          seconds = '' +  d.getSeconds();
    
      let timeSuffix = 'AM'
      if (hour === String(12)) {
          timeSuffix = 'PM'
      } else if (hour > 12) {
          hour = hour - 12;
          timeSuffix = 'PM'
      } else if (hour === String(0)) {
          hour = 12;
      }
      
  
      if (day.length < 2) 
          day = '0' + day;
      
      if (hour.length < 2) {
          hour = '0' + hour;
      }
      if (minutes.length < 2) {
          minutes = '0' + minutes;
      }
      if (seconds.length < 2) {
          seconds = '0' + seconds;
      }
  
      let formattedString = `${month}/${day}/${year}\n${hour}:${minutes}:${seconds} ${timeSuffix}`;
      return formattedString;
    }
  
    function setNoDataStates() {
      setWarningTemperature(0);
      setChartUpper(CHART_DEFAULT_MAXIMUM_FAHRENHEIT);
      setChartLower(CHART_DEFAULT_MINIMUM_FAHRENHEIT);
      setChartUnit('℉');
  
      setTemperatureData([]);
      setTemperatureDataCDCFeverArray([]);
      setTemperatureDataPersonalWarningArray([]); 
      setTemperatureDataProvisionalWarningArray([]); 
      setTemperatureDataChannelUpperArray([]); 
      setTemperatureDataChannelLowerArray([]); 
      setTemperatureDataMeanArray([]); 
    }
  
    function ProvisionalChart() {
      return (
        <ReactEcharts style={{minHeight:chartHeight, width:'99%'}}
          option={{
                  grid: {
                  containLabel: true
                  },
                  title: {
                  text: `Temperature Chart (Provisional)`,
                  subtextStyle:{color: 'black'},
                  },
                  tooltip: {
                  show: showOverlay,
                  trigger: 'axis',
                  axisPointer:{
                      label:{
                      formatter: function (value, index) {
                          // Formatted to be month/day; display year only in the first label
                          let date = new Date(value.value);
                          return date.toLocaleString(undefined, { timeZoneName: 'short' });
                        }
                      }
                  }
                  },
                  legend: {
                  type: 'scroll',
                  orient: 'horizontal',
                  right: 10,
                  top: 20,
                  bottom: 20,
                  icon:'rect'
                  },
              xAxis: {
                  nameLocation: 'center',
                  nameTextStyle: {padding: [0, 0, 0, 0]}, //[top, right, bottom, left]
                  nameGap: 40,
                  type: 'time',
                  axisLabel: {
                  show: true,
                  rotate: 45,
                  padding: [20,0,0,0],
                  formatter: function (value, index) {
                      let date = new Date(value);                        
                      return formatDate(date.toString());
                  }
                  }
              },
                  yAxis: {
                  name: `Temperature (${chartUnit})`,
                  nameLocation: 'center',
                  nameGap: 40,
                  type: 'value',
                  max: chartUpper,
                  min: chartLower,
                  axisLabel: {
                      show: true
                  },
                  minorTick: {
                      show: true
                  }
                  },
                  series: [
                  { 
                    data: temperatureData,
                    type: 'line',
                    color: 'blue',
                    name: 'Temperature',
                  },
                  { 
                  data: temperatureDataProvisionalWarningArray,
                  type: 'line',
                  color:'orange',
                  name: 'PWT',
                  showSymbol: false,
                  showLegendSymbol: true,
                  },
                  { 
                  data: temperatureDataCDCFeverArray,
                  type: 'line',
                  color:'red',
                  name: 'CDC Fever',
                  showSymbol: false,
                  showLegendSymbol: true,
                  },
              ],
          }}
      />);
  }
  
    function ProfileChart() {
    return (
      <ReactEcharts style={{minHeight:chartHeight, width:'99%'}}
          option={{
              grid: {
              containLabel: true
              },
              title: {
              text: `Temperature Chart`,
              subtextStyle:{color: 'black'},
              },
              tooltip: {
              show: showOverlay,
              trigger: 'axis',
              axisPointer:{
                  label:{
                  formatter: function (value, index) {
                      // Formatted to be month/day; display year only in the first label
                      let date = new Date(value.value);
                      return date.toLocaleString(undefined, { timeZoneName: 'short' });
                    }
                  }
              }
              },
              legend: {
              type: 'scroll',
              orient: 'horizontal',
              right: 10,
              top: 20,
              bottom: 20,
              icon:'rect'
          },
              xAxis: {
              nameLocation: 'center',
              nameTextStyle: {padding: [0, 0, 0, 0]}, //[top, right, bottom, left]
              nameGap: 40,
              type: 'time',
              axisLabel: {
                  show: true,
                  rotate: 45,
                  padding: [20,0,0,0],
                  formatter: function (value, index) {
                  let date = new Date(value);                        
                  return formatDate(date.toString());
                  }
              }
              },
              yAxis: {
              name: `Temperature (${chartUnit})`,
              nameLocation: 'center',
              nameTextStyle: {padding: [0, 0, 0, 0]}, //[top, right, bottom, left]
              nameGap: 40,
              type: 'value',
              max: chartUpper,
              min: chartLower,
              axisLabel: {
                  show: true
              },
              minorTick: {
                  show: true
              }
              },
              series: [
              { 
                  data: temperatureData,
                  type: 'line',
                  color: 'blue',
                  name: 'Temperature',                    
              },
              { 
                  data: temperatureDataPersonalWarningArray,
                  type: 'line',
                  color:'orange',
                  name: 'PWT',
                  showSymbol: false
              },
              { 
                  data: temperatureDataCDCFeverArray,
                  type: 'line',
                  color:'red',
                  name: 'CDC Fever',
                  showSymbol: false,
                  
              },
              { 
                  data: temperatureDataChannelUpperArray,
                  type: 'line',
                  color:'green',
                  name: 'Channel',
                  showSymbol: false,
                  showLegendSymbol: false,
                  lineStyle: {
                    type: "dashed"
                  }
              },
              { 
                  data: temperatureDataChannelLowerArray,
                  type: 'line',
                  color:'green',
                  name: 'Channel',
                  showSymbol: false,
                  showLegendSymbol: false,
                  lineStyle: {
                    type: "dashed"
                  } 
              },
              { 
                  data: temperatureDataMeanArray,
                  type: 'line',
                  color:'black',
                  name: 'Average',
                  showSymbol: false,
                  lineStyle: {
                  type: "dotted"
                  }
              },
          ],
                    
          }}
        />
  
    );
  }
    
    useEffect(() => { 
      async function loadPlottingData() {
        setShowBusy(true);
        // Fetch up-to-date health metrics from the latest temperature entry
        if (assessmentData == null) {
            setNoDataStates();
            if (showBusy) {
              setShowBusy(false);
            }
          return;
        } else {
            let localStartDate = startDate;
            let localEndDate = endDate;
            localStartDate.setHours(0,0,0,0);
            localEndDate.setHours(23,59,59,999);
            let plottingEntries = [];

            const user = await Auth.currentAuthenticatedUser()
            const token = user.signInUserSession.idToken.jwtToken
            const requestData = {
              headers: {
                Authorization: token
              },
              body: {
                start_date: localStartDate.getTime()/1000,
                end_date: localEndDate.getTime()/1000
              }
            }
            try {
              const data = await API.post('temperaturetrackapi', '/healthdata', requestData)
              if (data?.Items.length > 0) {
                plottingEntries = data.Items;
              }
              setPlottingData(plottingEntries);
            } catch (error) {
              console.log(error);
            }
        }
        
      }
  
      loadPlottingData();
    }, [assessmentData, startDate, endDate, showBusy]);
    
    useEffect(() => {
      function makeGraph() {
        if (assessmentData == null) {
            setNoDataStates();
            if (showBusy) {
              setShowBusy(false);
            }
          return;
        } else {
            const parsedTemperatureData: { temperature: string; unit: string; timestamp: string; docID: string}[] = [];
            let temperatures: any[] = [];
            let pwtLastUpdate = assessmentData;
            let plottingUnit = ''
            if (hasUpdatedPlottingUnit === true) {
              plottingUnit = preferredPlottingUnit;
            } else {
              plottingUnit = 'fahrenheit';
            }
            let plottingEntries = plottingData;
            // Prep all data for the user
            plottingEntries.forEach(function(doc) {
                let currentTemp = doc.temperature;
                if (plottingUnit === 'celsius') {  
                  currentTemp = Number(Math.round(parseFloat(fahrenheitToCelsius(parseFloat(currentTemp)) + 'e' + 2)) + 'e-' + 2)
                }
                temperatures.push(currentTemp);
                parsedTemperatureData.push({
                    temperature: currentTemp,
                    timestamp: doc.timestamp,
                });
            });
            let tempCDCFever = 0;
            let tempChannelUpper = 0;
            let tempChannelLower = 0;
            let tempChartUpper = 0;
            let tempChartLower = 0;
            let tempPersonalWarningTemperature = 0;
            let tempTemperatureDataMeanPlotting = 0;
            let tempProvisionalWarningTemperaturePlotting = 0;
            let tempPersonalWarningTemperaturePlotting = 0;
            let tempChartUnit = '';
  
            tempPersonalWarningTemperature = pwtLastUpdate.personal_warning_temperature
            tempTemperatureDataMeanPlotting = pwtLastUpdate.mean;
            tempPersonalWarningTemperaturePlotting = pwtLastUpdate.personal_warning_temperature
            
            tempChannelUpper = pwtLastUpdate.channel_upper;
            tempChannelLower = pwtLastUpdate.channel_lower;
      
            if (plottingUnit === 'fahrenheit') {
              tempChartUnit = '℉';
              tempProvisionalWarningTemperaturePlotting = PROVISIONAL_TEMPERATURE_FAHRENHEIT;
            } else if (plottingUnit === 'celsius') {
              tempChartUnit = '℃';
              tempProvisionalWarningTemperaturePlotting = PROVISIONAL_TEMPERATURE_CELSIUS;
              if (tempPersonalWarningTemperaturePlotting !== 0) {
                tempTemperatureDataMeanPlotting = fahrenheitToCelsius(parseFloat(tempTemperatureDataMeanPlotting));
                tempPersonalWarningTemperaturePlotting = fahrenheitToCelsius(parseFloat(tempPersonalWarningTemperaturePlotting));
                tempChannelUpper = fahrenheitToCelsius(parseFloat(tempChannelUpper));
                tempChannelLower = fahrenheitToCelsius(parseFloat(tempChannelLower));
              }
            }
    
            // Calculate bounds for the plot
            let max = Math.max(...temperatures);
            let min = Math.min(...temperatures);
    
            if (tempPersonalWarningTemperature !== 0) {
              max = Math.max(max, tempPersonalWarningTemperaturePlotting, tempChannelUpper);
              min = Math.min(min, tempChannelLower);
            }
            
            if (plottingUnit === 'fahrenheit') {
              if (max >= CDC_FEVER_FAHRENHEIT) {
                tempChartUpper = Math.round(max) + 1;
              } else {
                tempChartUpper = CHART_DEFAULT_MAXIMUM_FAHRENHEIT;
              }
              if (min <= (CHART_DEFAULT_MINIMUM_FAHRENHEIT + 0.8)) {
                tempChartLower = Math.round(min) - 1;
              } else {
                tempChartLower = CHART_DEFAULT_MINIMUM_FAHRENHEIT;
              }
              tempCDCFever = CDC_FEVER_FAHRENHEIT;
            } else {
              if (max >= CDC_FEVER_CELSIUS) {
                tempChartUpper = Math.round(max) + 1;
              } else {
                tempChartUpper = CHART_DEFAULT_MAXIMUM_CELSIUS;
              }
              if (min <= (CHART_DEFAULT_MINIMUM_CELSIUS + 0.5)) {
                tempChartLower = Math.round(min) - 1;
              } else {
                tempChartLower = CHART_DEFAULT_MINIMUM_CELSIUS;
              }
              tempCDCFever = CDC_FEVER_CELSIUS;
            }
    
            
    
            // Rounding
            tempPersonalWarningTemperaturePlotting = Number(Math.round(parseFloat(tempPersonalWarningTemperaturePlotting + 'e' + 2)) + 'e-' + 2);
            tempProvisionalWarningTemperaturePlotting = Number(Math.round(parseFloat(tempProvisionalWarningTemperaturePlotting + 'e' + 2)) + 'e-' + 2);
            tempTemperatureDataMeanPlotting = Number(Math.round(parseFloat(tempTemperatureDataMeanPlotting + 'e' + 2)) + 'e-' + 2);
            tempChannelUpper = Number(Math.round(parseFloat(tempChannelUpper + 'e' + 2)) + 'e-' + 2);
            tempChannelLower = Number(Math.round(parseFloat(tempChannelLower + 'e' + 2)) + 'e-' + 2);
            tempCDCFever = Number(Math.round(parseFloat(tempCDCFever + 'e' + 2)) + 'e-' + 2);
    
            // Building Arrays
            let temperatureDataArray = [];
            let tempTemperatureDataMeanArray = [];
            let tempTemperatureDataChannelUpperArray = [];
            let tempTemperatureDataChannelLowerArray = [];
            let tempTemperatureDataPersonalWarningArray = [];
            let tempTemperatureDataProvisionalWarningArray = [];
            let tempTemperatureDataCDCFeverArray = [];
    
            parsedTemperatureData.forEach(temperatureEntry => {
              temperatureDataArray.push([new Date(temperatureEntry.timestamp) * 1000, temperatureEntry.temperature]);
              tempTemperatureDataMeanArray.push([new Date(temperatureEntry.timestamp) * 1000, tempTemperatureDataMeanPlotting]);
              tempTemperatureDataChannelUpperArray.push([new Date(temperatureEntry.timestamp) * 1000, tempChannelUpper]);
              tempTemperatureDataChannelLowerArray.push([new Date(temperatureEntry.timestamp) * 1000, tempChannelLower]);
              tempTemperatureDataPersonalWarningArray.push([new Date(temperatureEntry.timestamp) * 1000, tempPersonalWarningTemperaturePlotting]);
              tempTemperatureDataProvisionalWarningArray.push([new Date(temperatureEntry.timestamp) * 1000, tempProvisionalWarningTemperaturePlotting]);
              tempTemperatureDataCDCFeverArray.push([new Date(temperatureEntry.timestamp) * 1000, tempCDCFever]);
            });
  
    
  
            setWarningTemperature(tempPersonalWarningTemperaturePlotting);
            
            // Plotting
            setChartUnit(tempChartUnit);
            setChartUpper(tempChartUpper);
            setChartLower(tempChartLower);
            setTemperatureData(temperatureDataArray.reverse());
            
            setTemperatureDataCDCFeverArray(tempTemperatureDataCDCFeverArray.reverse());
            setTemperatureDataPersonalWarningArray(tempTemperatureDataPersonalWarningArray.reverse()); 
            setTemperatureDataProvisionalWarningArray(tempTemperatureDataProvisionalWarningArray.reverse()); 
    
            setTemperatureDataChannelUpperArray(tempTemperatureDataChannelUpperArray.reverse()); 
            setTemperatureDataChannelLowerArray(tempTemperatureDataChannelLowerArray.reverse()); 
            setTemperatureDataMeanArray(tempTemperatureDataMeanArray.reverse()); 
    
            if (plottingUnit !== preferredPlottingUnit) {
              setPreferredPlottingUnit(plottingUnit);
            }
    
            setShowBusy(false); 
        }
      }
      makeGraph();
    }, [plottingData, preferredPlottingUnit, hasUpdatedPlottingUnit]); // eslint-disable-line react-hooks/exhaustive-deps
  
      return (
        <LoadingOverlay
          active={showBusy}
          spinner
          // text='Refreshing...'
          styles={{
            overlay: (base) => ({
              ...base,
            })
          }}
        >
        <div>     
          {(assessmentData == null && showBusy === false)
            ? 
              null
            : 
            <div>
              <div>   
                <div>
                {(plottingData.length < 1)
                    ?
                     <p>No data found to plot for the specified window.</p>
                    : 
                    <div>
                      {(warningTemperature !== 0)
                        ? 
                        <div>
                          <ProfileChart></ProfileChart>
                        </div>
                        : 
                        <div>
                          <ProvisionalChart></ProvisionalChart>
                        </div> 
                      }
                    </div>
                  }
                  <hr/>
                    <div> 
                      <p style={{fontSize: '1.4rem'}}>{`Options:`}</p>
                      <div style={{padding:5}}>
                      <Row>
                        <Col style={{backgroundColor:'whitesmoke'}}>
                            <div style={{padding:5}}>
                              <label><b>From</b>:</label>
                                <div>
                                <DatePicker selected={startDate} onChange={date => setStartDate(date)} />
                                </div>
                            </div>
                            <div style={{padding:5}}>
                              <label><b>To</b>:</label>
                              <div>
                                <DatePicker selected={endDate} onChange={date => setEndDate(date)}/>
                              </div>
                            </div>
                        </Col>
                        <Col sm = {true}>
                          <div style={{padding:5}}>
                            <label>Detail Overlay:</label>
                            <Button className='pwt-button' block size="sm"  type="button" onClick={() => setShowOverlay(!showOverlay)}>
                              {(showOverlay)
                              ? 'Disable'
                              : 'Enable'
                              }
                            </Button>
                          </div>
                          <div style={{padding:5}}>
                            <label>Unit:</label>
                            <select className="form-control" id="plottingUnitSelector" value={preferredPlottingUnit} onChange={ (e) => updatePlottingUnit(e.target.value)}>
                              <option value="fahrenheit">Fahrenheit</option>
                              <option value="celsius">Celsius</option>
                            </select>
                          </div>
                          
                        </Col>
                      </Row>
                      </div>
                      
                    </div>
                </div> 
              </div>
            </div>
          } 
      </div>
      </LoadingOverlay>           
      );
  }
  
  const TemperatureChartModule = compose(
  )(TemperatureChartModuleBase);
  
  export { TemperatureChartModule };
